var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.authPage)?_c('router-view'):_c('DashboardLayout',[_c('router-view')],1),_c('ToastContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }